// extracted by mini-css-extract-plugin
module.exports = {"pageIndicator":"PageIndicator_pageIndicator__13QhP","circle":"PageIndicator_circle__19iNS"};